import { render, staticRenderFns } from "./DesignationComponent.vue?vue&type=template&id=39f120ae&"
import script from "./DesignationComponent.vue?vue&type=script&lang=js&"
export * from "./DesignationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports